
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchWorkspaceNotifications } from 'actions'
import { getWorkspaceNotifications, getActiveWorkspaceSlug, getWorkspace, getCurrentUser } from 'selectors'
import { workspaceNotificationViewed, workspaceNotificationBodyClicked, workspaceNotificationUxClicked } from 'analytics'
import WorkspaceNotifications from '../components/WorkspaceNotifications'

class WorkspaceNotificationsApp extends Component {
  render () {
    return React.createElement(WorkspaceNotifications, this.props)
  }

  componentDidMount () {
    if (this.props.workspace && this.props.workspace.slug) {
      this.props.fetchWorkspaceNotifications(this.props.workspace.slug)
    }
  }
}

function mapStateToProps (state, { param }) {
  const slug = getActiveWorkspaceSlug(state)
  const workspace = getWorkspace(state, slug) || {}
  const notifications = getWorkspaceNotifications(state) || []
  const user = getCurrentUser(state)

  return {
    workspace,
    notifications,
    user
  }
}

function mapDispatchToProps (dispatch) {
  return {
    fetchWorkspaceNotifications: (slug) => dispatch(fetchWorkspaceNotifications(slug)),
    workspaceNotificationViewed: (workspace, user) => workspaceNotificationViewed(workspace, user),
    onNotificationClick: (workspace, user, category, title) => workspaceNotificationBodyClicked(workspace, user, category, title),
    workspaceNotificationUxClicked: (workspace, user) => workspaceNotificationUxClicked(workspace, user)
  }
}

WorkspaceNotificationsApp.propTypes = {
  fetchWorkspaceNotifications: PropTypes.func.isRequired,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    body: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    timestamp: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired,
  onNotificationClick: PropTypes.func.isRequired,
  workspace: PropTypes.object.isRequired,
  workspaceNotificationViewed: PropTypes.func.isRequired,
  workspaceNotificationUxClicked: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired
}

WorkspaceNotificationsApp.displayName = 'WorkspaceNotificationsApp'

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceNotificationsApp)



// WEBPACK FOOTER //
// ./containers/WorkspaceNotificationsApp.js